/**
 * TODO
 * - [ ] Add `validator` dependency and validate all inputs
 * - [ ] Handle zero case for advisor matches
 * - [ ] Add mutation for saving phone number
 */

import React from 'react';
import {
  ApolloClient,
  createNetworkInterface,
  ApolloProvider,
} from 'react-apollo';
import { connect } from 'react-redux';

import Segment from '../../components/Segment';

import WelcomeRoute from './routes/Welcome';
import QuestionsRoute from './routes/Questions';
import LoadingRoute from './routes/Loading';
import AdvisorsRoute from './routes/Advisors';
import BookingRoute from './routes/Booking';
import ConfirmationRoute from './routes/Confirmation';
import FallbackRoute from './routes/Fallback';

import './styles/shared.scss';

const segment = new Segment();

const mapStateToProps = state => ({
  authedUserID: state.auth.sub || null,
  authedUser: state.auth || null,
});

class RedirectToEntry extends React.PureComponent {
  componentWillMount() {
    segment.track('step0_entered');

    this.props.router.replace('/assessment/questions');
  }

  render() {
    return null;
  }
}

let lastPathname = '';

export const createRoutes = store => {
  return {
    path: 'assessment',
    component: connect(mapStateToProps)(props => {
      let GraphQLURI = __GraphQLPublic || publicEndpoint; // eslint-disable-line no-undef
      if (props.authedUserID !== null) {
        GraphQLURI = __GraphQLProtected || protectedEndpoint; // eslint-disable-line no-undef
      }

      let ApolloNetworkInstance = createNetworkInterface({
        uri: GraphQLURI,
        opts: {
          headers: {
            Authorization:
              'Bearer ' + (props.authedUser.rawToken || 'unauthed'),
          },
        },
      });

      let ApolloClientInstance = new ApolloClient({
        networkInterface: ApolloNetworkInstance,
      });

      if (props.location.pathname !== lastPathname) {
        // console.log('page', lastPathname, props.location.pathname);
        lastPathname = props.location.pathname;
        segment.page();
      }

      return (
        <ApolloProvider client={ApolloClientInstance}>
          {props.children ? (
            <div>{props.children}</div>
          ) : (
            <RedirectToEntry {...props} />
          )}
        </ApolloProvider>
      );
    }),
    childRoutes: [
      WelcomeRoute(store),
      QuestionsRoute(store),
      LoadingRoute(store),
      AdvisorsRoute(store),
      BookingRoute(store),
      ConfirmationRoute(store),
      FallbackRoute(store),
    ],
  };
};

export default createRoutes;



// WEBPACK FOOTER //
// ./src/routes/assessment/index.js